import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#20242b",
  textColor: "#f5f6fa",
  accentColor: "#ff7675",
  cardColor: "#2f3640",
  upward: "#DF7D46",
  downward: "#3C90EB",
};

export const lightTheme: DefaultTheme = {
  bgColor: "#f5f6fa",
  textColor: "#20242b",
  accentColor: "#ff7675",
  cardColor: "white",
  upward: "#DF7D46",
  downward: "#3C90EB",
};
